import React, { useState } from 'react'
import PersonAdmin from './PersonAdmin'
import FamilyAdmin from './FamilyAdmin'
import ImportPage from './ImportPage'

export default function UnifiedAdmin({ user, familyId }) {
  const [activeTab, setActiveTab] = useState('people')

  const tabs = [
    { id: 'people', label: 'People', component: PersonAdmin },
    { id: 'families', label: 'Families', component: FamilyAdmin },
    { id: 'import', label: 'Import', component: ImportPage },
  ]

  const ActiveComponent = tabs.find(tab => tab.id === activeTab)?.component

  return (
    <div className="min-h-[calc(100vh-64px)] py-6">
      <div className="max-w-7xl mx-auto px-4">
        {/* Tab Navigation */}
        <div className="glass-card p-2 mb-6">
          <div className="flex gap-2">
            {tabs.map(tab => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`flex-1 flex items-center justify-center gap-2 px-6 py-3 rounded-xl font-medium transition-all duration-200 ${
                  activeTab === tab.id
                    ? 'bg-gradient-to-r from-blue-500 to-purple-500 text-white shadow-lg scale-105'
                    : 'text-gray-700 dark:text-gray-300 hover:bg-white/30 dark:hover:bg-gray-700/30'
                }`}
              >
                <span className="text-sm md:text-base">{tab.label}</span>
              </button>
            ))}
          </div>
        </div>

        {/* Tab Content */}
        <div className="animate-fadeIn">
          {ActiveComponent && <ActiveComponent user={user} familyId={familyId} />}
        </div>
      </div>
    </div>
  )
}
